import React, { Component } from "react";
import moment from 'moment'

import tracking from "@/utils/tracking";
import DateCard from "@/components/atoms/DateCard";
import ButtonCTA from "@/components/atoms/ButtonCTA";

import "./article-card.scss";

class ArticleCard extends Component {
	onBookClick = url => {
		tracking.event("customEvent", {
			eventCategory: "Nav Link",
			eventAction: "click",
			eventLabel: `link: Book, source: ${window.location.pathname}`
		});

		window.location.href = url;
	};

	formatDate(date) {
		let formattedDate = moment(date, 'DD/MM/YYYY').format('dddd Do MMMM YYYY')
		return formattedDate
	}

	render() {
		const { article, routeProps, activeCategory } = this.props;
		let date = ''
		let title = ''
		let img = ''
		let slug = ''
		let description = ''
		let category = ''

		for (let j = 0; j < article.data.contents[0].fields.length; j++) {
			if (article.data.contents[0].fields[j].id === 'datepublished') {
				date = this.formatDate(article.data.contents[0].fields[j].value)
				continue
			} else if (article.data.contents[0].fields[j].id === 'title') {
				title = article.data.contents[0].fields[j].value
				continue
			} else if (article.data.contents[0].fields[j].id === 'heroimage') {
				for (let k = 0; k < article.data.contents[0].fields[j].fields.length; k++) {
					if (article.data.contents[0].fields[j].fields[k].id === 'heroimagelarge_') {
						img = article.data.contents[0].fields[j].fields[k].imgURL
					}
				}
				if (!img) {
					for (let l = 0; l < article.data.contents[0].fields[j].fields.length; l++) {
						if (article.data.contents[0].fields[j].fields[l].id === 'heroimagedefault') {
							img = article.data.contents[0].fields[j].fields[l].imgURL
							break
						}
					}
				}
				continue
			} else if (article.data.contents[0].fields[j].id === 'urlslug') {
				slug = article.data.contents[0].fields[j].value
				continue
			} else if (article.data.contents[0].fields[j].id === 'metainformation') {
				for (let m = 0; m < article.data.contents[0].fields[j].fields.length; m++) {
					if (article.data.contents[0].fields[j].fields[m].id === 'description') {
						description = article.data.contents[0].fields[j].fields[m].value
						break
					}
				}
				continue
			} else if (article.data.contents[0].fields[j].id === 'categoryfilters') {
				for (let n = 0; n < article.data.contents[0].fields[j].fields.length; n++) {
					if (article.data.contents[0].fields[j].fields[n].id === 'filter') {
						category = article.data.contents[0].fields[j].fields[n].value
						break
					}
				}
				continue
			}
		}

		return (
			<DateCard
				img={img}
				date={date}
				color={this.props.color}
				isActive={activeCategory === 'all' || activeCategory === category || this.props.isActive}
			>
				<div className="article-card__text">
					<h3 className="article-card__text-title">
						{title}
					</h3>
					<p className="article-card__text-description">
						{description}
					</p>
				</div>
				<div className="article-card__ctas">
					<ButtonCTA
						bordered
						customStyle="article-card__cta"
						label={this.props.cta}
						path={`/journal/${slug}`}
						handleClick={() => {
							window.scrollTo(0, 0);
							tracking.event("customEvent", {
								eventCategory: "Article card",
								eventAction: "click",
								eventLabel: `${title}, source: ${
									window.location.pathname
									}`
							});
						}}
					/>
				</div>
			</DateCard>
		);
	}
}

export default ArticleCard;



// WEBPACK FOOTER //
// ./src/components/molecules/ArticleCard/index.js